import React from 'react'

const Success = () => {
  return (
    <div>
      <h1>success</h1>
    </div>
  )
}

export default Success
